export const options = [{ text: 'active', value: 'active' }, { text: 'inactive', value: 'inactive' }, { text: 'snooze', value: 'snoozed' }];
export const containerStyles = { backgroundColor: '#f0f3ff', padding: 15, border: '1px solid #bfc6f3', marginTop: 15, marginBottom: 25 };
export const bannerStyles = { backgroundColor: '#475ddc', color: 'white', padding: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-between' };
export const bannerHeader = { fontWeight: 300, margin: 0 };
export const filterContainer = { width: 150 };
